import isBoolean from 'lodash/isBoolean';
import type { Source } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { Attributes } from '@atlassian/jira-product-analytics-bridge';
import getMeta from '@atlassian/jira-get-meta';
import { fg } from '@atlassian/jira-feature-gating';
import { isOverridingFragments } from '../environment/index.tsx';
import { getErrorType } from '../get-error-type/index.tsx';
import { isSynthetic } from '../synthetic/index.tsx';

export const parseSource = (source: Source) =>
	source != null ? source.toString() : 'unknownSource';

export const transformError = (error: Error) => ({
	...error,
	stack: error.stack,
	message: error?.message,
});

export const createAttributes = (rawAttributes?: Attributes): Attributes => {
	const attributes: Attributes = {
		isSynthetic: isSynthetic(),
		isOverridingFragments: isOverridingFragments(),
		isSSR: __SERVER__,
		...(fg('ditto-add-region-and-shard-to-op-analytics')
			? {
					shard: getMeta('ajs-shard') || '',
					region: getMeta('ajs-region') || '',
				}
			: {}),
	};

	if (rawAttributes) {
		const { source, error, hasForgeAccess } = rawAttributes;

		if (source) {
			attributes.source = parseSource(source);
		}

		if (error) {
			attributes.error = transformError(error);
			attributes.errorType = getErrorType(error);
		}

		if (isBoolean(hasForgeAccess)) {
			attributes.hasForgeAccess = hasForgeAccess;
		}
	}

	return { ...rawAttributes, ...attributes };
};
